const TRIGGER_CHECK_TIMEOUT_MS = 2000;
const MAX_TRIGGER_WORDS = 3;

/**
 * Quick local check: could this input be a trigger search?
 * Returns false if there are more than MAX_TRIGGER_WORDS words
 * (after stripping punctuation and collapsing whitespace).
 */
export function couldBeTriggerSearch(input: string): boolean {
    const cleaned = input.replace(/[\p{P}]/gu, "").trim();
    if (!cleaned) return false;
    const wordCount = cleaned.split(/\s+/).length;
    return wordCount <= MAX_TRIGGER_WORDS;
}

/**
 * Check if the input consists entirely of trigger words
 * (after stripping punctuation).
 */
export function isTriggerWordOnly(input: string, triggerWords: string[]): boolean {
    if (!triggerWords?.length) return false;
    if (!couldBeTriggerSearch(input)) return false;
    const cleaned = input.replace(/[\p{P}]/gu, "").trim();
    if (!cleaned) return false;
    const escaped = triggerWords.map((w) =>
        w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );
    const pattern = new RegExp(
        `^(\\s*(${escaped.join("|")})\\s*)+$`,
        "i"
    );
    return pattern.test(cleaned);
}

/**
 * Race a promise against a timeout. Rejects with "timeout" if the
 * promise doesn't resolve within the given duration.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number = TRIGGER_CHECK_TIMEOUT_MS): Promise<T> {
    return Promise.race([
        promise,
        new Promise<never>((_, reject) =>
            setTimeout(() => reject(new Error("trigger-check-timeout")), ms)
        ),
    ]);
}
